import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {TranslatePipe} from '@brunata-angular/util';

@Component({
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <div class="not-found">
            <h1>404</h1>
            <p class="fs-2">{{ 'errors_404_notFound' | translate: 'online' : 'common' }}</p>
            <button class="btn btn-primary" (click)="goToStartPage()">
                {{ 'actions_go_to_start_page' | translate: 'online' : 'common' }}
            </button>
        </div>
    `,
    styles: [
        `
            .not-found {
                text-align: center;
                margin-top: 3rem;
            }
            .not-found h1 {
                font-size: 6rem;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
    private readonly router = inject(Router);

    goToStartPage(): void {
        void this.router.navigate(['/']);
    }
}
